/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const GetSimulationCompanyFlexiproductQuery = gql`
  query GetSimulationCompanyFlexiproductQuery($idcc: String, $offerCodes: [String]) {
    getSimulationCompanyFlexiproduct_simulation_company(idcc: $idcc, offerCodes: $offerCodes) {
      canGoNext 
      ccnHasAgreement 
      error 
    }
  }
`;

export default GetSimulationCompanyFlexiproductQuery;
